import { render, staticRenderFns } from "./AssignedUserFilter.vue?vue&type=template&id=d1061956"
import script from "./AssignedUserFilter.vue?vue&type=script&lang=js"
export * from "./AssignedUserFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports